import { createContext } from "react";

const DonationMahotsavContext = createContext({});

export default DonationMahotsavContext;
